<template lang="pug">
div
  Navbar
  Hero(title="FanFair", subtitle="Content created by fans, for fans")
  FrontPage
  br
  br
  br
  Films
  Articles
  Videos
  Podcasts
  CharityCallout
  Footer
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Hero from "@/components/Hero.vue";
import FrontPage from "@/components/FrontPage.vue";
import Articles from "@/components/Articles.vue";
import Films from "@/components/Films.vue";
import Videos from "@/components/Videos.vue";
import Podcasts from "@/components/Podcasts.vue";
import CharityCallout from "@/components/CharityCallout.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",

  components: {
    Navbar,
    Hero,
    FrontPage,
    Articles,
    Films,
    Videos,
    Podcasts,
    CharityCallout,
    Footer
  }
};
</script>
